import { DepartureOption } from '@lt/api/dist/types/departure';
import DTOError from '../../../errors/DTOError';

/**
 * DTO, которая парсит данные для ручки отображения цен
 */
export const savedDepartureDTO = (data: unknown): DepartureOption => {
  if (
    data &&
    typeof data === 'object' &&
    'id' in data &&
    typeof data.id === 'number' &&
    'iso2' in data &&
    typeof data.iso2 === 'string' &&
    'label' in data &&
    typeof data.label === 'string' &&
    'value' in data &&
    typeof data.value === 'string' &&
    'selectedLabel' in data &&
    typeof data.selectedLabel === 'string'
  ) {
    return {
      id: data.id,
      iso2: data.iso2,
      label: data.label,
      value: data.value,
      selectedLabel: data.selectedLabel,
      isAutomaticallyDetected:
        'isAutomaticallyDetected' in data && typeof data.isAutomaticallyDetected === 'boolean'
          ? data.isAutomaticallyDetected
          : undefined,
      description:
        'description' in data && typeof data.description === 'string'
          ? data.description
          : undefined,
      distance: 'distance' in data && typeof data.distance === 'number' ? data.distance : undefined,
    };
  }

  throw new DTOError('savedDepartureDTO', data);
};
